import { Flex } from 'foundations-components/components/Flex';
import { useIsMobileView } from '../../hooks/useWindowSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const MainContentLayout = ({
  children
}) => {
  const isMobileView = useIsMobileView();
  return /*#__PURE__*/_jsx(Flex, {
    paddingInline: isMobileView ? '400' : '1400',
    paddingBlock: isMobileView ? '500' : '900',
    flexGrow: 1,
    flexDirection: "column",
    children: children
  });
};